import React from "react";
import axios from "axios";
import PropTypes from "prop-types";

import Button from "../Components/Button";

export default class AddToCart extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isAdding: false,
            hasAdded: false,
            hasFailed: false
        };
        this.handleAddToCart = this.handleAddToCart.bind(this);
        this.handlePushDataLayer = this.handlePushDataLayer.bind(this);
    }
    handlePushDataLayer() {
        const {
            product_id,
            product_category_name,
            product_name,
            product_price,
            sku,
            seller_id,
            seller_name
        } = this.props;

        if(window.dataLayer){
            const pushEvent = {
                event: "addToCart",
                ecommerce: {
                    currencyCode: "USD",
                    add: {
                        products: [{
                            name: product_name,
                            id: product_id,
                            price: product_price,
                            category: product_category_name,
                            seller_id: seller_id,
                            seller_name: seller_name,
                            adNo: sku
                        }]
                    }
                }
            };

            window.dataLayer.push(pushEvent);
        }
    }

    render() {
        let is_in_stock = this.props.is_in_stock;

        if (typeof is_in_stock === "string") {
            if (is_in_stock === "") {
                is_in_stock = true;
            } else {
                is_in_stock = false;
            }
        }

        return (
            <div onClick={this.props.onClick}>
                {is_in_stock ? (
                    <Button
                        label="Add to Cart"
                        loadingLabel="Adding to Cart..."
                        icon="far fa-shopping-cart"
                        className="btn highlight"
                        disabled={this.state.isAdding}
                        loading={this.state.isAdding}
                        success={this.state.hasAdded}
                        successMessage="Item successfully added to cart!"
                        fail={this.state.hasFailed}
                        failMessage={this.state.failMessage}
                        onClick={this.handleAddToCart}
                    />
                ) : (
                    <Button
                        label="Item is out of stock"
                        className="btn highlight"
                        disabled={true}
                    />
                )}
            </div>
        );
    }
    handleAddToCart() {
        this.handlePushDataLayer();

        this.setState({
            isAdding: true,
            hasAdded: false
        });
        const itemToAdd = {
            sku: this.props.sku,
            qty: 1
        };

        axios
            .post("/cart", itemToAdd)
            .then(() => {
                this.setState({
                    isAdding: false,
                    hasAdded: true
                });
            })
            .catch(err => {
                this.setState({
                    isAdding: false,
                    hasAdded: false,
                    hasFailed: true,
                    failMessage: err.response.data
                });
            })
            .then(() => {
                if (this.props.passHasAdded) {
                    this.props.passHasAdded(true);
                }
            });
    }
}

AddToCart.propTypes = {
    sku: PropTypes.string.isRequired,
    product_id: PropTypes.string,
    product_name: PropTypes.string,
    product_price: PropTypes.string,
    product_category_name: PropTypes.string,
    product_category_id: PropTypes.string,
    seller_id: PropTypes.string,
    seller_name: PropTypes.string,
    is_in_stock: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    passHasAdded: PropTypes.func,
    onClick: PropTypes.func,
    pushDataLayer: PropTypes.func
};
